import { getWord } from 'utils/tenant';

export const alertMinutesBeforeOptions = [
    { label: '15 minutes', value: 15 },
    { label: '30 minutes', value: 30 },
    { label: '45 minutes', value: 45 },
    { label: '60 minutes', value: 60 }
];

export const reminderDayOptions = [
    { label: 'the day of', value: 'the day of' },
    { label: 'the day before', value: 'the day before' }
];

export const getLoginPageOptions = (privileges) => {
    let options = [{ label: 'Default Login Page', value: 'DASH' }];
    
    if (privileges.hasConnect) {
        options.push(
            { label: 'Appointments -> Agenda', value: 'AGENDA' },
            { label: 'Appointments -> Day View', value: 'DAY' },
            { label: 'Appointments -> Week View', value: 'WEEK' }
        );
    }

    if (privileges.isCalendarManager)
        options.push({ label: 'Appointments -> Schedule View', value: 'SCHEDULE' });

    if (privileges.hasConnect || privileges.hasEarlyAlert)
        options.push({ label: 'Students -> My Students', value: 'STUDENTS' });

    if (privileges.shouldSeeInterventions)
        options.push({ label: 'Students -> Tracking', value: 'TRACKING' });

    if (privileges.shouldSeeZoomIn)
        options.push({ label: 'Students -> Zoom In', value: 'ZOOMIN' });

    if (privileges.shouldSeeAttendanceTracking)
        options.push({ label: 'Students -> Attendance', value: 'ATTENDANCE' });

    if (privileges.hasEarlyAlert && privileges.shouldSeeSurveys)
        options.push({ label: 'Students -> ' + getWord('progressSurveys'), value: 'SURVEYS' });
    
    return options;
};
